@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.rate-list {
  background: @rate-viewer-rate-list--background-color;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}

.rate-list-header {
  background: @rate-viewer-rate-list--header--background-color;
  height: 40px;
  position: relative;
  z-index: 2;
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
}

.provider-name {
  .truncate();
  font-size: 16px;
  max-width: 100%;
  color: @rate-viewer-rate-list--provider-name--text-color;
  line-height: 1.1;
}

.estimated-rates {
  font-size: 12px;
  color: @rate-viewer-rate-list--estimated-rates--text-color;
  white-space: nowrap;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.rate-list-content {
  max-height: calc(100% - 30px);
  height: calc(100% - 30px);
  position: relative;
  z-index: 1;
  overflow: hidden auto;
}

.loading-indicator {
  height: 100%;
  width: 100%;
}

.rates-error-indicator {
  padding: 20px;
}

.rates-error-message {
  margin-top: 50px;
  font-size: 14px;
  color: @rate-viewer-rate-list--rates-error-message-text-color;
  text-align: center;
  line-height: 16px;
}

.rate-list-item {
  border-bottom: 1px solid @rate-viewer-rate-list--rate-list-item--border-color;
}

.page-description {
  line-height: 1.5;
  margin-bottom: @space-12;
}

.header-tooltip {
  display: inline-block;
  margin-left: @space-4;

  .header-icon {
    height: 16px;
    color: @inline-message--info--text-color;
  }
}
